import React from 'react'
import { dateFormat } from '../../../constants/dateFormat'
import cardIcon from '../../../images/cardIcon.png'
import editIcon from '../../../images/editIcon.png'
import DateService from '../../../services/DateService'
import Switch from "react-switch";
import './UserCard.css'
import { Roles } from '../../../constants/Roles'

const UserCard = ({ onClick, show, elem, cardClassName, handleEditClick, handleChangeUserSwitch }) => {
    let { name, designation, is_active, manager, created_at, role_id, email, mobile, territories_name, states_name } = elem;
    let roleName = '';
    if (role_id === Roles.TM_ID) {
        roleName = "Territory Manager"
    } else if (role_id === Roles.SH_ID) {
        roleName = "State Head"
    } else if (role_id === Roles.NH_ID) {
        roleName = "National Head"
    } else if (role_id === Roles.BH_ID) {
        roleName = "Business Head"
    } else if (role_id === Roles.ADMIN_ID) {
        roleName = "Admin"
    }

    return (
        <div id='adminUserCard'>
            <div className='userData'>
                <div>
                    <div>Name : {name}</div>
                    <div className='d-flex flex-wrap'>
                        <span className='mr-3'>Designation : <span className={cardClassName ? cardClassName : ''}>{designation || 'N/A'}</span></span>
                        <span>Role : <span className={cardClassName ? cardClassName : ''}>{roleName}</span></span>
                    </div>
                    <div className='d-flex flex-wrap'>
                    {(role_id === Roles.TM_ID || role_id === Roles.SH_ID || role_id === Roles.NH_ID) ? <span className='mr-3'>State : {states_name ? states_name.map((elem, index) => {
                        return (
                            <span className={cardClassName ? cardClassName : ''} key={index}>{(index ? ', ' : '') + elem}</span>
                        )
                    }) : "N/A"}</span> : ''}
                    <span>Manager Name : <span className={cardClassName ? cardClassName : ''}>{manager && manager !== " " ? manager : 'N/A'}</span></span>
                    </div>
                    {role_id === Roles.TM_ID ? <div>Territory : {territories_name ? territories_name.map((elem, index) => {
                        return (
                            <span className={cardClassName ? cardClassName : ''} key={index}>{(index ? ', ' : '') + elem}</span>
                        )
                    }) : "N/A"}
                    </div> : ''}
                    <div>User Type : <span className={cardClassName ? cardClassName : ''}>{is_active ? 'Active' : 'Inactive'}</span></div>
                </div>
                {show ?
                    <div className='mt-3'>
                        <div>Mobile No : <span className={cardClassName ? cardClassName : ''}>{mobile || 'N/A'}</span></div>
                        <div>Email ID : <span className={cardClassName ? cardClassName : ''}>{email || 'N/A'}</span></div>
                        <div>User Created Date : <span className={cardClassName ? cardClassName : ''}>{DateService.localDateOnly(created_at, dateFormat.DATE_TIME_FORMAT_1) || 'N/A'}</span></div>
                    </div>
                    : ''}
            </div>
            <div className='d-flex flex-column justify-content-between'>
                <div className='text-right'>
                    <img src={editIcon} alt="cardIcon" width={20} height={20} className="cardIcon editIcon" onClick={handleEditClick} />
                    <img src={cardIcon} alt="cardIcon" width={20} height={20} className="cardIcon" onClick={onClick} />
                </div>
                <div className='mt-1 d-flex'>
                    <div className='mr-1'>{is_active ? 'Active' : 'Inactive'}</div>
                    <Switch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={20}
                        width={50}
                        handleDiameter={15}
                        onColor="#545CD8"
                        className="statusSwitch"
                        id="statusSwitch"
                        checked={is_active}
                        onChange={handleChangeUserSwitch}
                    />
                </div>
            </div>
        </div>
    )
}

export default UserCard
